/**
 * Patient Portal Protected Route
 * 
 * Wrapper component that ensures user is authenticated before
 * accessing patient portal pages.
 */

import { Navigate, useLocation } from 'react-router-dom';
import { usePatientAuth } from './PatientAuthContext';

export default function PatientProtectedRoute({ children }) {
  const { isAuthenticated, isLoading, mfaPending } = usePatientAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  // If MFA is pending, redirect to login to complete MFA
  if (mfaPending && !isAuthenticated) {
    return <Navigate to="/patient-portal/login" state={{ from: location }} replace />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/patient-portal/login" state={{ from: location }} replace />;
  }

  return children;
}
